import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AskQuestionsComponent } from './ask-questions.component';

const routes: Routes = [
  {path: 'askquestions-old', component: AskQuestionsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AskQuestionsRoutingModule { }
